/**
 * Build an ordered array of lessons for a course, sorted by
 * parent level position → sublevel position → lesson position.
 */
export function buildOrderedLessons(lessons, levels, courseId) {
  const courseLevels = Object.values(levels).filter(
    (l) => l.courseId === courseId
  );
  const levelsById = {};
  courseLevels.forEach((l) => {
    levelsById[l.id] = l;
  });

  // Build parent lookup: for each level, find its top-level parent
  const parentOf = {};
  courseLevels.forEach((level) => {
    let current = level;
    while (current.sublevelId && levelsById[current.sublevelId]) {
      current = levelsById[current.sublevelId];
    }
    parentOf[level.id] = current;
  });

  const courseLessons = Object.values(lessons).filter(
    (l) => l.courseId === courseId
  );

  // Sort: parent position → sublevel position → lesson position
  return courseLessons.slice().sort((a, b) => {
    const parentA = parentOf[a.levelId];
    const parentB = parentOf[b.levelId];
    const levelA = levelsById[a.levelId];
    const levelB = levelsById[b.levelId];

    // 1. Parent level position
    const pA = parentA?.position ?? Infinity;
    const pB = parentB?.position ?? Infinity;
    if (pA !== pB) return pA - pB;

    // 2. Sublevel position (0 if lesson is directly under parent)
    const sA = levelA?.sublevelId ? levelA.position ?? 0 : 0;
    const sB = levelB?.sublevelId ? levelB.position ?? 0 : 0;
    if (sA !== sB) return sA - sB;

    // 3. Lesson position
    return (a.position ?? 0) - (b.position ?? 0);
  });
}
